import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from './Modal';
import { SparkleIcon, DiamondIcon, ArrowRightIcon } from './icons/OrganicIcons';

const LandingPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleIniciaClick = () => {
    navigate('/inicia');
  };

  const handleClaraClick = () => {
    setIsModalOpen(true);
  };

  return (
    <div className={`min-h-screen portal-section transition-all duration-1000 ${mounted ? 'opacity-100' : 'opacity-0'}`}>
      {/* Fondo animado estilo Pixar */}
      <DigitalForestBackground />
      
      {/* Header con logo alineado a la izquierda */}
      <header className="relative z-20 flex flex-row items-center justify-start w-full pt-8 px-8">
        <img 
          src="/LOGO GUIA.png" 
          alt="GUIA AI Logo" 
          className="h-14 drop-shadow-2xl filter brightness-110 contrast-125"
          style={{ minWidth: 56 }}
        />
      </header>

      {/* Contenido principal */}
      <main className="relative z-10 flex flex-col items-center justify-center flex-1 px-6 py-12">
        {/* Título principal con estilo Pixar */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h1 className="text-5xl md:text-7xl font-light text-neutral-700 mb-6 leading-tight drop-shadow-lg">
            ¿En qué te podemos ayudar?
          </h1>
        </div>

        {/* Cards principales con estilo Pixar */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl w-full mb-16">
          {/* Card INICIA */}
          <div 
            onClick={handleIniciaClick}
            className="group cursor-pointer transform transition-all duration-700 hover:scale-105"
          >
            <div className="relative overflow-hidden rounded-[2rem] bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl hover:shadow-3xl transition-all duration-500 p-8 h-80 flex flex-col justify-center items-center text-center">
              {/* Efecto de brillo interno */}
              <div className="absolute inset-0 bg-gradient-to-br from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              {/* Icono con animación suave */}
              <div className="relative z-10 mb-6 transform group-hover:rotate-12 transition-transform duration-500">
                <SparkleIcon className="w-16 h-16 text-green-500 drop-shadow-lg" />
              </div>
              
              {/* Contenido */}
              <div className="relative z-10">
                <h2 className="text-3xl md:text-4xl font-light text-neutral-700 mb-4 leading-tight">
                  INICIA tu camino digital
                </h2>
                <p className="text-lg text-neutral-600 mb-6 leading-relaxed">
                  Descubre cómo la tecnología puede transformar tu trabajo diario
                </p>
                
                <div className="flex items-center justify-center space-x-2 text-green-600 group-hover:text-green-700 transition-colors duration-300">
                  <span className="text-sm font-medium">Comenzar</span>
                  <ArrowRightIcon className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" />
                </div>
              </div>
            </div>
          </div>

          {/* Card CLARA */}
          <div 
            onClick={handleClaraClick}
            className="group cursor-pointer transform transition-all duration-700 hover:scale-105"
          >
            <div className="relative overflow-hidden rounded-[2rem] bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl hover:shadow-3xl transition-all duration-500 p-8 h-80 flex flex-col justify-center items-center text-center">
              {/* Efecto de brillo interno */}
              <div className="absolute inset-0 bg-gradient-to-br from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              {/* Icono con animación suave */}
              <div className="relative z-10 mb-6 transform group-hover:rotate-12 transition-transform duration-500">
                <DiamondIcon className="w-16 h-16 text-blue-500 drop-shadow-lg" />
              </div>
              
              {/* Contenido */}
              <div className="relative z-10">
                <h2 className="text-3xl md:text-4xl font-light text-neutral-700 mb-4 leading-tight">
                  Convierte tu idea en proyecto: metodología CLARA
                </h2>
                <p className="text-lg text-neutral-600 mb-6 leading-relaxed">
                  Tu asistente personal para dar vida a tus proyectos
                </p>
                
                <div className="flex items-center justify-center space-x-2 text-blue-600 group-hover:text-blue-700 transition-colors duration-300">
                  <span className="text-sm font-medium">Próximamente</span>
                  <ArrowRightIcon className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer con estilo Pixar */}
      <footer className="relative z-20 flex flex-col items-center justify-center w-full pb-8 px-8">
        <div className="text-center">
          <p className="text-neutral-700 text-sm font-light leading-relaxed drop-shadow-sm" style={{ fontFamily: 'Poppins, Inter, sans-serif' }}>
            'Inteligencia que marca el rumbo'
          </p>
        </div>
      </footer>

      {/* Modal con estilo Pixar */}
      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="text-center p-8">
            <div className="mb-6 transform animate-bounce-gentle">
              <DiamondIcon className="w-16 h-16 text-green-400 mx-auto drop-shadow-lg" />
            </div>
            <h3 className="text-2xl font-light text-neutral-800 mb-4 leading-tight">
              ¡Próximamente!
            </h3>
            <p className="text-neutral-600 leading-relaxed">
              CLARA está en desarrollo. Muy pronto podrás convertir tus ideas en proyectos increíbles.
            </p>
          </div>
        </Modal>
      )}
    </div>
  );
};

// Componente de fondo digital forest con estilo Pixar
const DigitalForestBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {/* Gradiente de fondo más cálido y acogedor */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, #e8f5e8 0%, #b8e6ff 40%, #a3e6c1 80%, #e0fff7 100%)'
        }}
      />
      
      {/* Líneas verticales del bosque - más suaves y orgánicas */}
      {[...Array(15)].map((_, i) => (
        <div
          key={i}
          className="absolute top-0 w-1 bg-gradient-to-b from-transparent via-white/20 to-transparent"
          style={{
            left: `${Math.random() * 100}%`,
            height: '120vh',
            animation: `forest-down ${8 + Math.random() * 4}s linear infinite`,
            animationDelay: `${Math.random() * 8}s`,
            opacity: 0.3 + Math.random() * 0.4,
            filter: 'blur(0.5px)'
          }}
        />
      ))}
      
      {/* Partículas mágicas flotantes - más suaves y naturales */}
      {[...Array(20)].map((_, i) => (
        <div
          key={`particle-${i}`}
          className="absolute rounded-full bg-white/30 backdrop-blur-sm"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${4 + Math.random() * 8}px`,
            height: `${4 + Math.random() * 8}px`,
            animation: `particle-up ${10 + Math.random() * 10}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 10}s`,
            boxShadow: '0 0 10px rgba(255, 255, 255, 0.5)'
          }}
        />
      ))}
      
      {/* Halos de luz suaves */}
      {[...Array(8)].map((_, i) => (
        <div
          key={`halo-${i}`}
          className="absolute rounded-full bg-gradient-radial from-white/20 to-transparent"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${100 + Math.random() * 200}px`,
            height: `${100 + Math.random() * 200}px`,
            animation: `breathe ${6 + Math.random() * 4}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 6}s`
          }}
        />
      ))}
    </div>
  );
};

export default LandingPage; 